import { render, staticRenderFns } from "./TidyCal.vue?vue&type=template&id=1ae84666"
import script from "./TidyCal.vue?vue&type=script&lang=js"
export * from "./TidyCal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports